var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "15.729 22.082 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.708 25.104c-3.021-3.022-7.937-3.022-10.958 0-3.021 3.02-3.02 7.936 0 10.958 3.021 3.02 7.937 3.02 10.958-.001 3.02-3.021 3.02-7.936 0-10.957zm-.845 10.112a6.56 6.56 0 0 1-9.268 0 6.56 6.56 0 0 1 0-9.267 6.56 6.56 0 0 1 9.268 0 6.56 6.56 0 0 1 0 9.267zm-7.524-6.73a.906.906 0 1 1 1.811 0 .906.906 0 0 1-1.811 0zm4.106 0a.906.906 0 1 1 1.812 0 .906.906 0 0 1-1.812 0zm2.141 3.708c-.561 1.298-1.875 2.137-3.348 2.137-1.505 0-2.827-.843-3.369-2.147a.438.438 0 0 1 .81-.336c.405.976 1.41 1.607 2.559 1.607 1.123 0 2.121-.631 2.544-1.608a.438.438 0 0 1 .804.347z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.0d5cfde56c56fbf33845e17114930f0b.svg";
export { ForwardRef as ReactComponent };